<!-- 
<button
  type="button"
  class="redeem-card"
  (click)="pick.emit(option)"
>
  <div class="redeem-card__img"
      [ngStyle]="
        styleService.getStyleRule(
          [tab?.configurations?.modal?.redeemCardBackground, null, 'main'],
          undefined,
          undefined
        )
      "
  >
    <img *ngIf="option.imageLink" [src]="option.imageLink" alt="" />
    <div *ngIf="!option.imageLink" class="imgFallback"></div>
  </div>

  <div
    class="redeem-card__title"
    [ngStyle]="
      styleService.getStyleRule([
        tab?.configurations?.modal?.redeemCardTitle,
        null,
        'heading6'
      ])
    "
  >
    {{
      option.name
        | conditionalUppercase
          : styleService.getUppercaseValue(tab?.configurations?.modal?.redeemCardTitle)
    }}
  </div>
</button> -->
<button
  type="button"
  class="redeem-card"
  (click)="pick.emit(option)"
  [ngStyle]="
    styleService.getStyleRule(
      undefined,
      [tab?.configurations?.modal?.redeemCardBackground, 'undefined', 'undefined'],
      undefined
    )
  "
>
  <div class="redeem-card__img">
    <img *ngIf="option.imageLink" [src]="option.imageLink" alt="" />
    <div *ngIf="!option.imageLink" class="imgFallback"></div>
  </div>

  <div
    class="redeem-card__title"
    [ngStyle]="
      styleService.getStyleRule([
        tab?.configurations?.modal?.redeemCardTitle,
        null,
        'heading6'
      ])
    "
  >
    {{
      option.name
        | conditionalUppercase
          : styleService.getUppercaseValue(tab?.configurations?.modal?.redeemCardTitle)
    }}
  </div>
</button>